export const EXPERIMENT_PRIMARY_ACTION_CLASS = [
  "bg-gradient-to-br from-orange-400 to-orange-600 text-white",
  "shadow-[0_0_0_4px_rgba(255,138,61,0.15),0_10px_28px_rgba(255,107,26,0.38),0_2px_6px_rgba(0,0,0,0.12)]",
  "transition duration-150 hover:-translate-y-px hover:from-orange-500 hover:to-orange-700 hover:text-white",
  "disabled:translate-y-0 disabled:shadow-none",
].join(" ");
